export class OffsetPageRequestModel {
    constructor(
        public skip: number | null,
        public take: number | null
    ) { }
}
